import { useWizard } from '@synqo/frontend-component-library';
import { type RefObject, useEffect } from 'react';

/** How far the wizard walked through the answered steps on its own, and whether it still does. */
export interface Skipping {
    /** Whether the walk goes on. */
    active: boolean;
    /** The step last stepped on from, so a step re-rendered before the next one mounts is not left twice. */
    from: number | undefined;
}

/** Steps the wizard on, as "Weiter" would, while the walk through the answered steps goes on. */
// @ai-generated 2026-09-29T09:54:18+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
export function StepOnWhenAnswered({ skipping }: { skipping: RefObject<Skipping> }) {
    const { activeIndex, isLast, errors, goNext } = useWizard();
    const refused = Object.keys(errors).length > 0;

    useEffect(() => {
        const state = skipping.current;
        if (!state.active) {
            return;
        }

        if (isLast || refused) {
            state.active = false;
            return;
        }

        if (state.from === activeIndex) {
            return;
        }

        state.from = activeIndex;
        void goNext();
    }, [skipping, activeIndex, isLast, refused, goNext]);

    return null;
}
